const settings = {
    en: {
        "settings.title": "Settings & dictionaries",
        "settings.general": "General settings",
        "settings.companyName": "Company name",
        "settings.supportPhone": "Support phone",
        "settings.supportEmail": "Support email",
        "settings.itemsPerPage": "Items per page",
        "settings.defaultLanguage": "Default language",
        "settings.save": "Save settings",
        "settings.dictionaries": "Dictionaries",
        "settings.type": "Type",
        "settings.value": "Value",
        "settings.label": "Label",
        "settings.order": "Order",
        "settings.enabled": "Enabled",
        "settings.add": "Add",
        "settings.newType": "New dictionary type",
        "settings.delete": "Delete",
        "settings.update": "Save",
        "settings.confirmDelete": "Delete this item?",
        "settings.saved": "Saved",
    },
    ru: {
        "settings.title": "Настройки и справочники",
        "settings.general": "Общие настройки",
        "settings.companyName": "Название компании",
        "settings.supportPhone": "Телефон поддержки",
        "settings.supportEmail": "Email поддержки",
        "settings.itemsPerPage": "Записей на странице",
        "settings.defaultLanguage": "Язык по умолчанию",
        "settings.save": "Сохранить настройки",
        "settings.dictionaries": "Справочники",
        "settings.type": "Тип",
        "settings.value": "Значение",
        "settings.label": "Название",
        "settings.order": "Порядок",
        "settings.enabled": "Включено",
        "settings.add": "Добавить",
        "settings.newType": "Новый тип справочника",
        "settings.delete": "Удалить",
        "settings.update": "Сохранить",
        "settings.confirmDelete": "Удалить элемент?",
        "settings.saved": "Сохранено",
    },
    geo: {
        "settings.title": "პარამეტრები და ლექსიკონები",
        "settings.general": "ზოგადი პარამეტრები",
        "settings.companyName": "კომპანიის სახელი",
        "settings.supportPhone": "მხარდაჭერის ტელეფონი",
        "settings.supportEmail": "მხარდაჭერის ელფოსტა",
        "settings.itemsPerPage": "ჩანაწერი გვერდზე",
        "settings.defaultLanguage": "ნაგულისხმევი ენა",
        "settings.save": "პარამეტრების შენახვა",
        "settings.dictionaries": "ლექსიკონები",
        "settings.type": "ტიპი",
        "settings.value": "მნიშვნელობა",
        "settings.label": "სახელი",
        "settings.order": "რიგი",
        "settings.enabled": "ჩართული",
        "settings.add": "დამატება",
        "settings.newType": "ახალი ლექსიკონის ტიპი",
        "settings.delete": "წაშლა",
        "settings.update": "შენახვა",
        "settings.confirmDelete": "წავშალო ეს ელემენტი?",
        "settings.saved": "შენახულია",
    },
};

export default settings;
